

import { toggleModal, ADD_CATEGORY_TO_LIST, UPDATE_CATEGORY_IN_LIST, DELETE_CATEGORY_FROM_LIST, 
        ADD_POINTS_TO_LIST, GROUP_BY_CATEGORIES_WITH_SUB_CATEGORIES, GROUP_BY_EMPLOYEES_WITH_ROLES,
        ADD_LEADERBOARD_POINTS_TO_LIST, ADD_SINGLE_POINT_TO_LEADERBOARD_POINT_LIST, ADD_ALL_TIME_LEADERBOARD_POINTS_TO_LIST,
         ADD_MY_POINTS_OVERVIEW, SUBTRACT_REDEEM_REQUEST_FROM_MY_WALLET_POINTS
        } from "./mutation-types";

export default {

        [toggleModal]: (state, value) =>{
            state.isShowAddOrUpdateModal = value;
        },

        [ADD_POINTS_TO_LIST]: (state, pointsList) =>{
            state.pointsList = pointsList ;
        },
        
        [ADD_CATEGORY_TO_LIST]: (state, category) =>{
            state.categoriesList.push(category);
        },

        [UPDATE_CATEGORY_IN_LIST]: (state, updatedCategory) =>{
            const index = state.categoriesList.findIndex(category => category.id === updatedCategory.id);
            state.categoriesList[index] = updatedCategory
        },

        [DELETE_CATEGORY_FROM_LIST]: (state, categoryIDs) => {
            state.categoriesList.forEach((element, index) => { 
                categoryIDs.forEach(id=>{
                     if( id == element.id || id === element.id){
                        state.categoriesList.splice(index, 1);
                     }
                        
                });
            });

          },

        [GROUP_BY_CATEGORIES_WITH_SUB_CATEGORIES]: (state, categoriesObject) =>{

            const categoriesList = categoriesObject.categoriesList
            const subCategoriesList =  categoriesObject.subCategoriesList

            // Create a mapping of category names to their respective subcategories
            const categoriesMap = {};
            for (const category of categoriesList) {
                categoriesMap[category.name] = {
                    group_name: category.name,
                    list: []
                };
            }

            // Populate the list of subcategories for each category
            for (const subCategory of subCategoriesList) {

                const categoryName = subCategory.category;
                const parentCategory = subCategory.parentCategory;

                const points = subCategory.points !== null && subCategory.points !== 0 ? subCategory.points : parentCategory.default_points;

                categoriesMap[categoryName].list.push({
                    id: subCategory.id,
                    name: subCategory.name,
                    parentCategory: subCategory.parentCategory,
                    // ... include other properties of the subCategory
                    points: points
                });
            }

            // Convert the categoriesMap into an array of values
            const categoriesListGroup = Object.values(categoriesMap);
            state.categoriesList = categoriesListGroup
        
        },

        [GROUP_BY_EMPLOYEES_WITH_ROLES]: (state, employeesList) =>{
            const loggedInUserId = localStorage.getItem("userId")
            employeesList = employeesList.filter(employee=> {return employee.id !== loggedInUserId})
            employeesList = employeesList.filter(employee=> {return employee.role !== "ADMIN" && employee.role !== "SUPER_ADMIN"});
            const groupedEmployees = employeesList.reduce((groups, employee) => {
                const groupIndex = groups.findIndex(group => group.group_name === employee.role);
                
                if (groupIndex !== -1) {
                    groups[groupIndex].list.push({ id: employee.id, name: employee.name,is_active:employee.is_active });
                } else {
                    groups.push({
                        group_name: employee.role,
                        list: [{ id: employee.id, name: employee.name,is_active:employee.is_active }]
                    });
                }
                
                return groups;
            }, []);
            
            state.employeeList = groupedEmployees
        
        },

        [ADD_LEADERBOARD_POINTS_TO_LIST]: (state, leaderBoardPointsList) =>{
            state.leaderBoardPointsList = leaderBoardPointsList ;
        },
        [ADD_ALL_TIME_LEADERBOARD_POINTS_TO_LIST]: (state, allTimeLeaderBoardPointsList) =>{
            state.allTimeleaderBoardPointsList = allTimeLeaderBoardPointsList ;
        },
        [ADD_SINGLE_POINT_TO_LEADERBOARD_POINT_LIST]: (state, point) =>{
            state.leaderBoardPointsList.push(point);
        },
        [ADD_MY_POINTS_OVERVIEW]: (state, myPointsOverview) =>{
            state.myPointsOverview.weeklyRemainingPoints = myPointsOverview.weeklyRemainingPoints;
            state.myPointsOverview.walletPoints = myPointsOverview.walletPoints;
        },
        // receiving minus on add, receiving plus on update
        [SUBTRACT_REDEEM_REQUEST_FROM_MY_WALLET_POINTS]: (state, pointObj) =>{
            const oldPoints = state.myPointsOverview.walletPoints
            if(pointObj.operation == "ADD"){
                state.myPointsOverview.walletPoints = oldPoints + pointObj.points
            }else{
                state.myPointsOverview.walletPoints = oldPoints - pointObj.points
            }
        },
          
}
